import GetStart from './GetStart';
import Share from './Share';
import Upholstery from './Upholstery';
import FrameFinish from './FrameFinish';
import AddionalFeatures from './AddionalFeatures';

const accords = {
  GetStart,
  Share,
  Upholstery,
  FrameFinish,
  AddionalFeatures,
};

export default accords;



// WEBPACK FOOTER //
// ./src/components/accords/index.js